import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { BankIdLogo } from '@components/BankIdLogo'
import { forceRedirect } from '@methods/forceRedirect'
import { API_URL } from '@constants/apiUrl'

export const BankIdRetryPage = observer(() => {
  const store = useContext(StoreContext)
  const { bankIdRetryPage: trans } = store.TranslationsState.translations

  const handleRetry = () => {
    forceRedirect(`${API_URL}/eid/retry?action=retry`)
  }

  const handleCancel = () => {
    forceRedirect(`${API_URL}/eid/retry?action=cancel`)
  }

  return (
    <div className="page-container mobile-m-10">
      <div className="layout__centered-content">
        <BankIdLogo />
      </div>
      <span className="layout__margin-only m-10" />
      <p className="generic__paragraph-centered">{trans.description}</p>

      <div className="generic__bank-id-retry__button-wrap">
        <div className="button generic__bank-id-retry__button" onClick={() => handleRetry()}>
          <span className="generic__button-text">{trans.retry}</span>
        </div>

        <div
          className="button generic__bank-id-retry__button cancel"
          onClick={() => handleCancel()}
        >
          <span className="generic__button-text">{trans.cancel}</span>
        </div>
      </div>
    </div>
  )
})
